import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { BaseComponent } from '../../../base.component';
import { User } from '../../../../models/ui/user.model';
import { LexbeCase } from '../../../../models/case.model';
import { CaseManager } from '../../../../managers/case.manager';
import { MatSelectionListChange } from '@angular/material/list';

@Component({
    selector: 'lex-manage-case-access-dialog',
    templateUrl: './manage-case-access-dialog.component.html',
    styleUrls: ['./manage-case-access-dialog.component.scss'],
    standalone: false
})
export class ManageCaseAccessDialogComponent extends BaseComponent {

	public cases: LexbeCase[];
	public selectedUser: User = null;
	public selectedAccountName: string = '';
	public formChanged: boolean = false;
	public selection: SelectionModel<string>;
	public selectedCaseIds: string[] = [];

	private selectedAccountId: string = '';

	constructor(
		private dialogRef: MatDialogRef<ManageCaseAccessDialogComponent>,
		private caseManager: CaseManager,
		@Inject(MAT_DIALOG_DATA) private data: any) {
		super();
		this.selectedUser = data.selectedUser;
		this.selectedAccountId = data.selectedAccountId;
		this.selectedAccountName = this.selectedUser.accounts.find(x => x.accountId === this.selectedAccountId).accountName;
		this.caseManager.getCasesByAccountId(this.selectedAccountId).subscribe(data => {
			this.cases = data;
		});
		this.selectedCaseIds = this.selectedUser.cases?.map(x => x.caseId);
		this.selection = new SelectionModel<string>(true, this.selectedCaseIds);
	}

	public submit(): void {
		this.selectedCaseIds = this.selection.selected;
		this.dialogRef.close(this.selectedCaseIds);
	}

	public changeCaseIds(selection: MatSelectionListChange): void {
		selection.options.forEach((option) => {
			if (option.selected) {
				this.selection.select(option.value);
			} else {
				this.selection.deselect(option.value);
			}
		});
		if (!this.formChanged)
			this.formChanged = true;
	}

}
